import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useState } from 'react';
import Hint from '../../components/Hint/Hint';
import useAdminMenuHighlight from '../../hooks/useAdminMenuHighlight';
import './License.scss';
const License = () => {
    useAdminMenuHighlight(); 
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')    

    const [processingSend, setProcessingSend] = useState(false)
    const [processingSendRing, setProcessingSendRing] = useState(false)
    const [processingSendTick, setProcessingSendTick] = useState(false)

    // useEffect(() => {
    //     fetchHistories();
    // }, []);

    const handleForm = async () => {
        if (subject && message) {
            setProcessingSend(true)
            setProcessingSendRing(true)
            try {
                const result = await apiFetch({
                    path: "/ultimate-security/v1/feedback",
                    method: "POST",
                    data: {
                        _wpnonce: ultimate_security_ajax_obj.security,
                        subject: subject,
                        message: message
                    }
                });
                console.log(result)
                if (result.success) {  
                    setSubject("")
                    setMessage("")              
                    setProcessingSend(false)
                    setProcessingSendRing(false)
                }
            } catch (error) {
                console.error("Mail Sending Error:", error);
                setProcessingSend(false)
                setProcessingSendRing(false)
            }
        } else {
            alert('Subject or Message can\'t be Empty')
        }
        
    };

    return (
        <>
            <div className='ultimate-security-license-wrapper'>
                <div className="container-fluid">
                    {/* <div className="form-header pb-lg mb-lg border-bottom">
                        <PageHeading
                            title={__("Give Feedback on your experience using Ultimate Security", 'ultimate-security')}
                            subtitle={__("We are improving our product on a regular momenetum. Your feedback is gonna help us get ahead of the curve and provide a robust security solution for you.", "ultimate-security")}
                        />
                    </div> */}
                    <div className="setting-unit pb-lg mb-lg border-bottom">
                        <div className="">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("License Key", "ultimate-security")}</h5>
                            <p className="pl-body">
                                {__("Need Help?", "ultimate-security")} <a href="">{__("Read the Instruction", "ultimate-security")}</a>
                            </p>
                            <p className="pl-body">
                                {__("The license key is used to access automatic updates and support.", "ultimate-security")}
                            </p>
                            <div className="button-wrapper d-flex align-items-center gap-3 mb-3">
                                <button type="button" className="button button-secondary">{__("View my account", "ultimate-security")}</button>
                                <button type="button" className="button button-secondary">{__("Reset your license", "ultimate-security")}</button>
                            </div>
                            <p><strong>{__("Steps to follow to activate your license:", "ultimate-security")}</strong></p>
                            <ol>
                                <li>{__("Paste your license key", "ultimate-security")}</li>
                                <li>{__("Save changes", "ultimate-security")}</li>
                                <li>{__("Activate License", "ultimate-security")}</li>
                            </ol>
                            <p>{__("That\'s it", "ultimate-security")}</p>
                            <p>{__("You can also use the define [SEOPRESS_LICENSE_KEY] to automatically activate your license key. Learn more", "ultimate-security")}</p>
                            <p>{__("You can also use the define [SEOPRESS_LICENSE_KEY] to automatically activate your license key. Learn more", "ultimate-security")}</p>
                            <p><a href="">{__("Download unauthorized? - Can't activate?", "ultimate-security")}</a></p>
                        </div>
                    </div>
                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Limit Attempts Pro License", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-12">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <input 
                                                className="form-control"
                                                type="text"
                                                // value={settingData?.login?.active_logins?.max_session}
                                                // onChange={(e) => handleChange('login.active_logins.max_session', e.target.value)}
                                            />                                            
                                            <div className="d-flex align-items-center gap-2">
                                                <button type="button" className="button button-link">{__("Activate", "ultimate-security")}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-12">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <div 
                                                className="d-flex align-items-center justify-content-between"
                                                style={{flex:1}}
                                            >
                                                <h5 className="pl-heading-1 fw-600 text-text m-0">{__("License Holder: ", "ultimate-security")}</h5>
                                                <span>{__("GPL (noreply@gmail.com)", "ultimate-security")}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-12">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <div 
                                                className="d-flex align-items-center justify-content-between"
                                                style={{flex:1}}
                                            >
                                                <h5 className="pl-heading-1 fw-600 text-text m-0">{__("Plan: ", "ultimate-security")}</h5>
                                                <span>{__("CheckoutWC Agency", "ultimate-security")}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-12">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <div 
                                                className="d-flex align-items-center justify-content-between"
                                                style={{flex:1}}
                                            >
                                                <h5 className="pl-heading-1 fw-600 text-text m-0">{__("Activation Limit: ", "ultimate-security")}</h5>
                                                <span>{__("50", "ultimate-security")}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-12">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <div 
                                                className="d-flex align-items-center justify-content-between"
                                                style={{flex:1}}
                                            >
                                                <h5 className="pl-heading-1 fw-600 text-text m-0">{__("Expiry date: ", "ultimate-security")}</h5>
                                                <span>{__("01/01/2026", "ultimate-security")}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-between mt-2">
                                    <div className="col-lg-12">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <div 
                                                className="d-flex align-items-center justify-content-between"
                                                style={{flex:1}}
                                            >
                                                <h5 className="pl-heading-1 fw-600 text-text m-0">{__("Status: ", "ultimate-security")}</h5>
                                                <span className="license-status active">{__("Activated", "ultimate-security")}</span>
                                            </div>
                                        </div>
                                        <div className="content-below-with-hint mt-2">
                                            <div className="green-text">{__("Your license key is valid and active for this site.", "ultimate-security")}</div>
                                            <div className="blue-text mt-2"><a href="">{__("Refresh License Info", "ultimate-security")}</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Manage License Settings", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sit, harum!", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <div className="d-flex align-items-center gap-2">
                                                <button type="button" className="button button-link">{__("Save Change", "ultimate-security")}</button>
                                            </div>
                                        </div>
                                        <div className="content-below-with-hint mt-2">
                                            <p className="pl-body text-text">{__("Manage active licenses, download BWS products, and view your payment history using BestWebSoft Client Area.", "ultimate-security")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default License;